import tEditor from './editor.vue';

export default {
  install(instance: any) {
    instance.component('tEditor', tEditor);
  },
};
